import { render, staticRenderFns } from "./Signos.vue?vue&type=template&id=0ace701a&"
import script from "./Signos.vue?vue&type=script&lang=js&"
export * from "./Signos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports